import React, { Component } from 'react';
import { Grid, Cell, List, ListItem, ListItemContent } from 'react-mdl';


class Contact extends Component {
  render() {
    return(
      <div className="contact-body">
        <h2>Contact Information</h2>
        <hr/>
        <div className="contact-list">
              <List>
                <ListItem >
                  <ListItemContent style={{fontSize: '25px'}}>
                    <i className="fa fa-phone-square" aria-hidden="true" style={{color: '#fda07d'}}/>
                    +47 948 02 840
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent style={{fontSize: '25px'}}>
                    <i className="fa fa-envelope" aria-hidden="true" style={{color: '#fda07d'}}/>
                    98mpett@gmail.com
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent style={{fontSize: '25px'}}>
                    <i className="fa fa-linkedin-square" aria-hidden="true" style={{color: '#fda07d'}}/>
                    <a href="https://www.linkedin.com/in/mpett/" style={{color:'black'}}>Linkedin/mpett</a>
                  </ListItemContent>
                </ListItem>
              </List>
        </div>
      </div>
    )
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact.js